import type { FormattedString } from '@sysarb/sysarb-types-v2/services/v1/pay-equity-audit';

export const EMPTY_VALUE = '-';

export const HIDDEN_VALUE = '***';

/**
 * Format a FormattedString into a display string.
 */
export function formatString(value: FormattedString | null | undefined): string {
    if (value == null) return EMPTY_VALUE;

    switch (value.type) {
        case 'empty':
            return EMPTY_VALUE;
        case 'hidden':
            return HIDDEN_VALUE;
        case 'value':
            return value.value;
        default:
            return EMPTY_VALUE;
    }
}

/**
 * Convert a plain string from an endpoint that doesn't send FormattedString yet.
 * Visibility is checked first, so a hidden empty value doesn't reveal that it is empty.
 */
export function toFormattedString(value: string | null | undefined, isVisible: boolean): FormattedString {
    if (!isVisible) return { type: 'hidden' };
    if (value == null || value === '') return { type: 'empty' };
    return { type: 'value', value };
}
